import { render, staticRenderFns } from "./FlowPublicBySelfDetail.vue?vue&type=template&id=3578fa1f&scoped=true"
import script from "./FlowPublicBySelfDetail.vue?vue&type=script&lang=js"
export * from "./FlowPublicBySelfDetail.vue?vue&type=script&lang=js"
import style0 from "./FlowPublicBySelfDetail.vue?vue&type=style&index=0&id=3578fa1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3578fa1f",
  null
  
)

export default component.exports